'use strict';

const attributeNames = {
  extraDiscount: 'data-formatted-extra-discount',
  discountPercentage: 'data-discount-percentage',
  offerLabel: 'data-offer-label',
  price: 'data-formatted-price',
  regularPrice: 'data-formatted-regular-price',
  value: 'data-formatted-value',
};

const classNames = {
  bannerMessage: 'juice-banner-message',
  juiceProgramEnabled: 'juice-program-enabled',
  juiceProgramExpired: 'juice-program-expired',
};

const baseSelectors = {
  bannerMessage: `.${classNames.bannerMessage}`,
  discountBadge: '.breakout-pricing-messages .discount-message-wrapper',
  extraDiscount: `.${classNames.bannerMessage} .extra-discount`,
  offerLabel: '.breakout-pricing-messages .urgency-pricing-label',
  timerInBannerMessage: `.${classNames.bannerMessage} .time-left`,
  doubleStrikePrice: '.breakout-option-regular-price',
};

const inlineSelectors = {
  ...baseSelectors,
  input: '.m-option-b input',
  wrapper: '#purchase-cluster',
};

const modalSelectors = {
  ...baseSelectors,
  input: '.multi-option-overlay-item input',
  wrapper: '.multi-option-overlay',
  overlayClusterDiscount: '.multi-option-overlay-cluster-row .discount-message',
  overlayClusterPrice: '.multi-option-overlay-cluster-price',
  viewMoreButton: '#purchase-cluster .view-options a',
};

module.exports = {
  attributeNames,
  classNames,
  inlineSelectors,
  modalSelectors,
};
